import React, { FC, useEffect, useState } from 'react'
import { ActiveFeature, LotViewName } from '../../../../types/lot.interface'
import { useTranslation } from 'react-i18next'
import { getNightParkingTimesFromConfigMemoized } from '../../../../utils/getNightParkingTimesFromConfig.utils'
import { NightParkingTimesContainer } from '@views/PaymentSuccess/PaymentSuccess.style'

interface Props {
    active_features?: ActiveFeature[] | null
    start_time?: string
    end_time?: string
    sundayIncluded?: boolean
}

const NightParkingTimes: FC<Props> = ({ active_features, start_time, end_time, sundayIncluded }) => {
    const [times, setTimes] = useState<{ start_time: string; end_time: string }>()
    const { t } = useTranslation()

    useEffect(() => {
        if (start_time && end_time) return
        if (active_features) {
            const feature = active_features.find(
                (f) => f.name.toLocaleLowerCase() === LotViewName.NIGHTLY.toLowerCase()
            )
            if (!feature) return
            const { start, end } = getNightParkingTimesFromConfigMemoized(feature)
            setTimes({ start_time: start, end_time: end })
        }
    }, [active_features, start_time, end_time])

    return (
        <NightParkingTimesContainer>
            <span>
                {start_time ? start_time : times?.start_time} - {end_time ? end_time : times?.end_time}{' '}
                {t('checkout.hour')}
            </span>
            {sundayIncluded && <span>{t('lot.sundayIncluded')}</span>}
        </NightParkingTimesContainer>
    )
}

export default NightParkingTimes
